




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class DiagnoseTable extends Vue {
	@Prop({ default: () => [] })
	private list!: any

	private columns: any = [
		{
			title: '序号',
			dataIndex: 'index',
			scopedSlots: { customRender: 'index' },
		},
		{
			title: '诊断名称',
			dataIndex: 'clinicalDiagnosis',
		},
		{
			title: '损伤部位I',
			dataIndex: 'injuredPartOne',
		},
		{
			title: '损伤分类',
			dataIndex: 'injuredSort',
		},
		{
			title: '手术名称',
			dataIndex: 'operationDesc',
		},
		{
			title: '骨折类型',
			dataIndex: 'fractureType',
			scopedSlots: { customRender: 'fractureType' },
		},
		{
			title: '后续治疗项目',
			dataIndex: 'followTreatmentDesc',
		},
	]

	private get tableData() {
		return this.list.map((diagnoseItem: any, index: number) => {
			let operationDesc = '',
				followTreatmentDesc = ''
			operationDesc = (diagnoseItem.operationList || [])
				.map((operation: any) => operation.operationName)
				.join('，')
			followTreatmentDesc = (diagnoseItem.followTreatmentList || [])
				.map((followItem: any) => followItem.cuteItem)
				.join('，')

			return {
				index,
				diagnosisCode: diagnoseItem.diagnosisCode,
				fractureType: diagnoseItem.fractureType,
				clinicalDiagnosis: diagnoseItem.clinicalDiagnosis || '--',
				injuredPartOne: diagnoseItem.injuredPartOne || '--',
				injuredSort: diagnoseItem.injuredSort || '--',
				operationDesc: operationDesc || '--',
				followTreatmentDesc: followTreatmentDesc || '--',
			}
		})
	}
}
